import * as React from 'react'
import { IconWithText } from '@components/icon-with-text'

export const LocalForClientWithBenefitNotAvailable = (): JSX.Element => (
  <div>
    <p className="mt-4">
      Wybrany lokal jest w tym terminie <strong>niedostępny.</strong>
    </p>
    <p>
      Zachęcamy do kontaktu z naszym <strong>Biurem Obsługi Klienta</strong>, które chętnie pomoże znaleźć dla Państwa
      najlepsze możliwe rozwiązanie.
    </p>
    <section className="rounded p-3 subscription-with-benefits-owner-modal__contact-banner">
      <p className="font-size-sm text-darker-gray mb-2 fw-bold">Skontaktuj się z nami - postaramy się pomóc!</p>
      <IconWithText text="735 200 800" iconClassName="uil-mobile-android me-2" wrapperClassName="text-purple" />
    </section>
  </div>
)
